import React from "react";
import Tabs from "../tabs/tab";
import TabPane from "../tabs/tab-pane";
import DriverTab from "../driverDetailsTabs/driverTab";
import VehicleTab from "../driverDetailsTabs/vehicleTab";
import RidesTab from "../driverDetailsTabs/ridesTab";
import LocationTab from "../driverDetailsTabs/locationTab";
import LicenseTab from "../driverDetailsTabs/licenseTab";

const DriverDetails = () => {
    return (
        <div className="ta__dashboard">
            <div className="ta__dashboard__body pb-5">
                <div className="ta__usertable mt-0">
                    <Tabs>
                        <TabPane name="Driver" key="1">
                            <DriverTab />
                        </TabPane>
                        <TabPane name="Driver License" key="2">
                            <LicenseTab />
                        </TabPane>
                        <TabPane name="Vehicle Info" key="3">
                            <VehicleTab />
                        </TabPane>
                        <TabPane name="Rides" key="4">
                            <RidesTab />
                        </TabPane>
                        <TabPane name="Location" key="5">
                            <LocationTab />
                        </TabPane>
                        <TabPane name="Driver Payments" key="6">
                            Coming Soon...
                        </TabPane>
                        <TabPane name="Status" key="7">
                            Coming Soon...
                        </TabPane>
                        <TabPane name="Payments" key="8">
                            Coming Soon...
                        </TabPane>
                        <TabPane name="Performance" key="9">
                            Coming Soon...
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </div >
    )
}

export default DriverDetails